const SENTRY_ORGANIZATION   = 'magnitt-hq';

// for server-side rendering
const SENTRY_PROJECT_SERVER = 'magnitt-react-server-side';
const SENTRY_DSN_SSR = 'https://cbfc34a8859492c608407d074df88f85@o4506931166838784.ingest.us.sentry.io/4507338791190528';

// for client-side rendering
const SENTRY_PROJECT_CLIENT = 'magnitt-react-client-side';
const SENTRY_DSN_CSR = 'https://d978c4da5c16f71274eea456c07cd973@o4506931166838784.ingest.us.sentry.io/4507345525669888';

// errors that should not be tracked in sentry
const SENTRY_ERRORS_TO_IGNORE = [
    /Network Error/i,
    /Request aborted/i, // network issues / timeout / left page
    /Timeout/i,
    // errors from Outlook web crawler 'Safe Links' feature
    // https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/38
    // https://github.com/getsentry/sentry-javascript/issues/3440
    "Non-Error promise rejection captured with value: Object Not Found Matching Id:5, MethodName:update, ParamCount:4",
    "Non-Error promise rejection captured with value: Object Not Found Matching Id:5, MethodName:simulateEvent, ParamCount:1",
    // bots/headless browsers (Selenium, Puppeteer, stealth plugins) re-patching navigator.webdriver on themselves
    "Cannot redefine property: webdriver",
    // no stack trace possible when the rejection value itself carries no info (usually a third-party embed/extension)
    "Non-Error promise rejection captured with value: null",
    "Non-Error promise rejection captured with value: undefined"
]

// browser extensions (Grammarly, LastPass, etc.) monkey-patch fetch/XHR and throw on their own - not actionable for us
// denyUrls matches against where the error was actually thrown, not every frame in the stack
const SENTRY_DENY_URLS = [
    /^chrome-extension:\/\//,
    /^moz-extension:\/\//,
    /^safari-web-extension:\/\//,
]

module.exports = {
    SENTRY_ORGANIZATION,
    SENTRY_PROJECT_SERVER,
    SENTRY_PROJECT_CLIENT,
    SENTRY_DSN_SSR,
    SENTRY_DSN_CSR,
    SENTRY_ERRORS_TO_IGNORE,
    SENTRY_DENY_URLS
};